<template>
  <div class="modal fade" id="confirmPassword" role="dialog" @click="$emit('close')">
    <div class="modal-dialog" @click.stop>
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header nav01_bg_color">
          <button type="button" class="close text-white" data-dismiss="modal" @click="$emit('close')">&times;</button>
        </div>
        <div class="modal-body">
          <form autocomplete="off" @submit.prevent="confirmPassword">
            <div class="form-group">
              <label for="password" class="control-label label-normal">ログインパスワードを再入力して下さい。</label>
              <input type="password" name="password" id="password" class="form-control" v-model.trim="password" v-validate="'required|max:64'" data-vv-as="ログインパスワード" @input="$emit('resetErr')" :disabled="isDisabled">
              <span style="display: block" v-show="errors.has('password')" class="text-danger">※{{ errors.first('password') }}</span>
              <span style="display: block" v-if="err" class="text-danger" v-html="'※' + err"></span>
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-warning w-120" data-dismiss="modal" :disabled="isDisabled">確認</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: ['err'],

  data () {
    return {
      password: null,
      isDisabled: false
    }
  },

  watch: {
    isShowModal () {
      this.isDisabled = this.isShowModal
    }
  },

  computed: {
    ...mapGetters({
      isShowModal: 'getIsShowModal'
    })
  },

  mounted () {
    $('#confirmPassword').modal('show')
  },

  methods: {
    async confirmPassword () {
      this.$emit('resetErr')
      let result = await this.$validator.validateAll()
      if (result) {
        this.$emit('confirm', this.password)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalConfirmPassword.vue